<template>
    <div
         :style="`
         padding-right:${bodypadding}px;
         padding-left:${bodypadding}px;
         display:inline;width:100%;
         background-color: ${active?'beige':'transparent'};`">
        <div style="text-align: center;">
            <p style="font-family:verdana;color:#6b6b6b;font-size:75%;">
                We are a opt-in only platform. If you wish to be removed from our mailing list, please follow this link
                <a :href="$store.state.url+'/unsubscribe/ee'" target="_blank">Unsubscribe</a>
            </p>
            <address style="text-align:center">
                <span style="font-size:12px">{{org.info.line1}}, {{org.info.city}}, {{org.info.state}}&nbsp;{{org.info.zip}}</span>
            </address>
            <address style="text-align:center"><span style="font-size:12px">Phone {{org.info.phone}}</span></address>
            <address style="text-align:center">
                <a :href="org.info.website" target="_blank">
                    <span style="font-size:12px">{{org.info.website}}</span>
                </a>
            </address>
        </div>
    </div>
</template>

<script>
  import{
    mapState
  } from 'vuex'
  export default {
    props:['d','active','bodypadding'],
    components: {},
    name: "BFooter",
    data() {
      return {}
    },
    computed:{
      ...mapState(['icons','org'])
    }
  }
</script>


<style scoped>

</style>